import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Router, Redirect } from 'react-router-dom'
import { RegisterPage } from '../RegisterPage';
import { LoginPage } from '../LoginPage';
import { ProfilePage } from '../ProfilePage';
import { CreateEventPage } from '../CreateEventPage';
import { Page404 } from '../Page404';
import { LeadsPage } from '../LeadsPage';
import { EventMainPage, EventSettingsPage, EventQrcodePage, EventImagesPage, PrintImagesPage } from '../EventPage';
import { AllEventsPage } from '../AllEventsPage';
import { AuthActions, LeadsActions } from '../../actions';
import { history } from '../../helper';
import { PrivateRoute, Offline } from './';
import { Messages } from '../Messages';
import './index.scss';

class App extends Component {

    constructor(props) {
        super(props);

        this.props.dispatch(AuthActions.isUserLoggedIn());
    }

    componentWillUpdate(newProps) {    
        const {auth, dispatch} = this.props;    
        if(newProps.auth && newProps.auth.loggedIn === true) {
            // call it only once
            if(!(auth && auth.loggedIn === true)) {
                dispatch(LeadsActions.getAllLeads());
            }
        }
    }

    render () {
        return (
            // waiting for version 5 of https://www.npmjs.com/package/react-router-redux
            // and use react-router-redux for handle history
            // read more https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
            <div className="main">
                <Router history={history}>
                    <Switch>
                        <Route path='/register' component={RegisterPage}/>
                        <Route path='/login' component={LoginPage}/>
                        <PrivateRoute exact path="/profile" component={ProfilePage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>                    
                        <PrivateRoute exact path="/events" component={AllEventsPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>                        
                        <PrivateRoute exact path="/events/create" component={CreateEventPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>
                        <PrivateRoute exact path="/events/:eventID" component={EventMainPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>
                        <PrivateRoute exact path="/events/:eventID/settings" component={EventSettingsPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>
                        <PrivateRoute exact path="/events/:eventID/qrcode" component={EventQrcodePage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>                        
                        <PrivateRoute exact path="/events/:eventID/images" component={EventImagesPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>                                                
                        <PrivateRoute exact path="/events/:eventID/print/:printID" component={PrintImagesPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>                                                                        
                        <PrivateRoute exact path="/leads" component={LeadsPage} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>                                                                                                
                        <PrivateRoute exact path="/" render={() => (<Redirect to="/events" />)} component={null} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>
                        <PrivateRoute exact path="*" component={Page404} loggedIn={this.props.auth.loggedIn} waitForProcess={this.props.auth.process}/>
                    </Switch>
                </Router>
                <Messages/>
                <Offline /> 
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer
    }
}

const AppWithRedux = connect(mapStateToProps)(App);

export {AppWithRedux as App};


// WEBPACK FOOTER //
// ./src/components/App/App.jsx